/* eslint-disable no-unused-vars */

import Footer from "../Layout/Footer";
import { CommonPageData } from "../../styles/common.style";
import { GrClose } from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const steps_sm = [
  {
    title: "Complete a quick intake form",
    subtitle:
      "Tell us about your current or past injuries, goals, and areas of concern.",
  },
  {
    title: "Watch a step-by-step instruction video.",
    subtitle:
      "Learn exactly how to film your movements for the most accurate results.",
  },
  {
    title: "Record & upload your movement Images or videos.",
    subtitle:
      "Follow our instructions to capture your movement from multiple angles using just your phone.",
  },
  {
    title: "Get your results.",
    subtitle:
      "Our AI analyzes your images and assigns your personalized corrective program — in minutes.",
  },
];
const steps_lg = [
  {
    title: "Complete a Quick Intake Form",
    subtitle:
      "Tell us about your current or past injuries, goals, and areas of concern.",
  },
  {
    title: "Watch a Step-By-Step Instruction Video",
    subtitle:
      "Learn exactly how to film your movements for the most accurate results.",
  },
  {
    title: "Record & Upload Your Movement Images or Videos",
    subtitle:
      "Follow our instructions to capture your movement from multiple angles using just your phone.",
  },
  {
    title: "Get Your Results",
    subtitle:
      "Our AI analyzes your images and assigns your personalized corrective program — in minutes.",
  },
];

const requirements = [
  "Only 30-45 minutes of uninterrupted time",
  "Form-fitting workout clothes",
  "A phone & tripod (or someone to help film)",
  "Enough space to move safely",
];

const AssesmentInfo = () => {
  const navigate = useNavigate();

  const handleExit = () => {
    navigate("/home");
  };
  const [showLeftPanel, setShowLeftPanel] = useState(true);
  const [showRightPanel, setShowRightPanel] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        if (!showLeftPanel) {
          setShowRightPanel(true);
        } else {
          setShowRightPanel(false);
        }
      } else {
        setShowRightPanel(true);
      }
    };

    // Run once on mount
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [showLeftPanel]);

  return (
    <>
      <CommonPageData>
        <div className="assesment-details-info">
          <div className="container">
            {showLeftPanel && (
              <div className="left_panel">
                <div onClick={handleExit} class="exit_button">
                  <GrClose size={20} />
                </div>
                <div className="top_part">
                  <h3 className="red_text bold_text">You're In!</h3>
                  <h3 className="sub">
                    Let's walk you through what comes next.
                  </h3>
                </div>

                <p className="description">
                  This isn’t just a quiz — it’s a hands-on, 30–45 minute guided
                  process designed to discover your Body Type and assign the
                  right corrective program.
                </p>

                <div className="rules_step">
                  <h3 className="header">
                    What to expect from the Assessment:
                  </h3>

                  <div className="steps sm">
                    {steps_sm.map((item, index) => (
                      <div key={index} className="single_step">
                        <p className="title">
                          <span> {index + 1}. </span> <span>{item.title}</span>
                        </p>
                        <p className="subtitle"> {item.subtitle} </p>
                      </div>
                    ))}
                  </div>
                  <div className="steps lg">
                    {steps_lg.map((item, index) => (
                      <div key={index} className="single_step">
                        <p className="title">
                          <span> {index + 1}. </span> <span>{item.title}</span>
                        </p>
                        <p className="subtitle"> {item.subtitle} </p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* next step navigation */}
                <div class="next-step-navigation">
                  <button
                    onClick={() => {
                      navigate(-1);
                    }}
                    className="ms-cta-btn secondary"
                  >
                    Back
                  </button>
                  <button
                    onClick={() => {
                      setShowLeftPanel(false);
                      setShowRightPanel(true);
                    }}
                    className="ms-cta-btn"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}

            {showRightPanel && (
              <div className="right_panel">
                <div onClick={handleExit} class="exit_button">
                  <GrClose size={20} />
                </div>
                <h3 className="top_title">
                  <span className="hero">Get Ready to Discover</span>{" "}
                  <span className="sub">Your BODY TYPE!</span>
                </h3>

                <div class="requirement-box-wrapper">
                  <div className="requirement_box">
                    <div className="inner"></div>
                    <p className="title">What you will need:</p>

                    <ul className="list">
                      {requirements.map((item, index) => (
                        <li key={index} className="item">
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="button_holder">
                  <a href="/intake-form" className="ms-cta-btn">
                    Start Assessment
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </CommonPageData>
      <Footer />
    </>
  );
};

export default AssesmentInfo;
